import React from "react";
const About = () => {
    return (<>
        <div id="abo" className="About1">
            <h1>About Me</h1>
            <div className="About2">
                <div className="profile_img" data-aos="fade-up">

                </div>
                <div className="profile_info" data-aos="fade-up">
                    <div>
                        <p>
                            B.Tech CSE student highly interested in web technologies.I'm familiar with HTML,CSS,Javascipt and Reactjs...
                        </p>
                        <p>
                            I love to make responsive websites with latest technologies,components and libraries.
                        </p>
                    </div>
                    <div class="button-container">
                        <a href="Vineet_Rajanikant_Jadhav_Resume.pdf" target="_blank" rel="noopener noreferrer" class="download-button">Download Resume</a>
                    </div>

                </div>

            </div>
        </div>
    </>)
}
export default About